import { fetchWithAuth } from '../auth'

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST

export async function getAssetDashboard() {
  const resp = await fetchWithAuth(`${API_HOST}assets/dashboard/`, { credentials: 'include' })
  if (!resp.ok) throw new Error('Failed to fetch asset dashboard')
  return resp.json()
}

export async function getTeamAssetDetail(teamId) {
  const resp = await fetchWithAuth(`${API_HOST}assets/dashboard/${teamId}/`, { credentials: 'include' })
  if (!resp.ok) throw new Error(`Failed to fetch asset details for team ${teamId}`)
  return resp.json()
}
